import {useContext} from "react";
import HeaderPage from "../components/HeaderPage";
import {View} from "react-native";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {CardView} from "../components/CardView";
import Text from "../components/Text";
import {threeDigitsSep} from "../../../helpers";
import OrderHistoryList from "../../../components/data-components/OrderHistoryList";

export default function OrdersHistory({navigation}: any) {

    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <HeaderPage title={"تاریخچه سفارشات"} scrollableContent={true}>
        <OrderHistoryList renderItem={(item) => {
            return <CardView scheme={"elevated"}>
                <View style={{flexDirection: "row", justifyContent: "space-between"}}>
                    <Text size={14}
                          color={colors.get("highConText") as string}>{`کد سفارش: ${item.item.orderCode}`}</Text>
                    <Text>{item.item.finalizationTimeAgo}</Text>
                </View>
                <View style={{flexDirection: "row"}}>
                    <CardView style={{flex: 1}} scheme={"flat"} mh={0} mv={6}
                              backColor={colors.get("primaryColor") as string}>
                        {item.item.orderItemsStringArray().map((item, index) => {
                            return <Text size={14} color={"white"}>{`${index + 1}) ${item}`}</Text>
                        })}
                    </CardView>
                </View>
                <View style={{flexDirection: "row"}}>
                    <View style={{flexGrow: 1}}>
                        <Text color={colors.get("lowConText") as string} weight={300}>نوع پرداخت:</Text>
                        <Text color={colors.get("lowConText") as string} weight={300}>قیمت کل:</Text>
                        <Text color={colors.get("lowConText") as string} weight={300}>نوع تحویل:</Text>
                        <Text color={colors.get("lowConText") as string} weight={300}>وضعیت:</Text>
                    </View>
                    <View style={{flexGrow: 1}}>
                        <Text color={colors.get("highConText") as string}
                              weight={600}>{item.item.getPaymentTypeStringTag()}</Text>
                        <Text color={colors.get("highConText") as string}
                              weight={600}>{`${threeDigitsSep(item.item.totalPayablePrice ?? 0)} تومان`}</Text>
                        <Text color={colors.get("highConText") as string}
                              weight={600}>{item.item.getDeliveryStringTag()}</Text>
                        <Text color={item.item.getLastStageInfo()?.getColor(colors)}
                              weight={600}>{item.item.getLastStageStatusText()}</Text>
                    </View>
                </View>
            </CardView>
        }}/>
    </HeaderPage>
}